<template>
  <div :class="['row full-width vonix-truncate-chip-labels bg-white', files.length ? 'q-mt-sm' : '']">
    <div
      class="col-auto"
      v-for="attach in files"
      :key="`${attach.id}-${attach.progress}`"
    >
      <q-chip
        outline
        square
        dense
        color="primary"
        style="background: #fff"
        :removable="!attach.uploading"
        @remove="remove(attach)"
      >
        <div class="ellipsis">
          <q-spinner-ios
            color="primary"
            v-if="attach.uploading"
          /> {{ attach.uploading ? `${attach.progress}%` : '' }} {{ attach.fileName }}
        </div>

        <q-tooltip v-if="!attach.uploading">
          {{ attach.fileName }}
        </q-tooltip>
      </q-chip>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UploadButton',

  props: {
    refId: {},
    refType: {},
    isDisabled: { default: false }
  },

  computed: {
    ...mapState({
      files ({ uploadModule }) {
        const files = Array.isArray(uploadModule.files) ? [...uploadModule.files] : []
        return files.filter((attach) => {
          return attach.refId === this.refId && attach.refType === this.refType
        })
      }
    })
  },

  methods: {
    ...mapActions({
      removeAttach: 'uploadModule/removeAttach'
    }),

    remove ({ id }) {
      this.removeAttach({
        refId: this.refId,
        refType: this.refType,
        id
      })
    }
  }
}

</script>

<style lang="sass" scoped>
  .vonix-truncate-chip-labels
    .q-chip
      max-width: 210px
</style>
